<main>
    <div id="selection-grid">
        <div>&nbsp</div>
        <button  id="valediction-button" class="valediction-button-selected select-button"
        on:click={selectValediction}>Valediction</button>
        <div>Message</div>
        <select class="select" bind:value={$user.selected_valediction} on:click={selectValediction}>
            {#each $user.valediction_list || [] as valediction}
                <option value={valediction}>
                    {valediction}
                </option>
            {/each}
        </select>
    </div>
</main>

<style>

    #selection-grid {
        display: grid;
        grid-template-columns: auto auto;
        justify-items: start;
        row-gap: 0.5vh;
        column-gap: 0.5vh;
    }
</style>

<script>
    import { get } from 'svelte/store';
    import { user, state } from './data-store.js'
    import { buildMessage, switchGreetingValidation } from './common.js';

    function selectValediction() {
        get(state).mode = 'v'
        get(state).message = buildMessage()
        switchGreetingValidation()
    }
</script>